import {
  container,
  defaultFont,
  primaryColor,
  infoColor,
  successColor,
  warningColor,
  dangerColor,
  roseColor,
  transition,
  boxShadow,
  drawerWidth
} from "../../assets/style";

const headerStyle = theme => ({
  appBar: {
    display: "flex",
    border: "0",
    color: "#555",
    width: "100%",
    backgroundColor: "#fff",
    boxShadow:
      "0 4px 18px 0px rgba(0, 0, 0, 0.12), 0 7px 10px -5px rgba(0, 0, 0, 0.15)",
    transition: "all 150ms ease 0s",
    alignItems: "center",
    flexFlow: "row nowrap",
    justifyContent: "flex-start",
    position: "relative",
    zIndex: "unset"
  },
  container: {
    ...container,
    minHeight: "50px",
    flex: "1",
    alignItems: "center",
    justifyContent: "space-between",
    display: "flex",
    flexWrap: "nowrap"
  },
  flex: {
    flex: 1
  },
  title: {
    ...defaultFont,
    lineHeight: "30px",
    fontSize: "18px",
    borderRadius: "3px",
    textTransform: "none",
    color: "inherit",
    padding: "8px 16px",
    letterSpacing: "unset",
    "&:hover,&:focus": {
      color: "inherit",
      background: "transparent"
    }
  },
  appResponsive: {
    margin: "20px 10px"
  },
  primary: {
    backgroundColor: primaryColor,
    color: "#FFFFFF",
    boxShadow:
      "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(156, 39, 176, 0.46)"
  },
  info: {
    backgroundColor: infoColor,
    color: "#FFFFFF",
    boxShadow:
      "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(0, 188, 212, 0.46)"
  },
  success: {
    backgroundColor: successColor,
    color: "#FFFFFF",
    boxShadow:
      "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(76, 175, 80, 0.46)"
  },
  warning: {
    backgroundColor: warningColor,
    color: "#FFFFFF",
    boxShadow:
      "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(255, 152, 0, 0.46)"
  },
  danger: {
    backgroundColor: dangerColor,
    color: "#FFFFFF",
    boxShadow:
      "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(244, 67, 54, 0.46)"
  },
  rose: {
    backgroundColor: roseColor,
    color: "#FFFFFF",
    boxShadow:
      "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(233, 30, 99, 0.46)"
  },
  transparent: {
    backgroundColor: "transparent !important",
    boxShadow: "none",
    paddingTop: "25px",
    color: "#FFFFFF"
  },
  dark: {
    [theme.breakpoints.down("sm")]: {
      color: "#555",
      backgroundColor: "#fff !important",
      boxShadow:
        "0 4px 18px 0px rgba(0, 0, 0, 0.12), 0 7px 10px -5px rgba(0, 0, 0, 0.15)"
    },
    color: "#FFFFFF",
    backgroundColor: "#000 !important",
    boxShadow:
      "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(33, 33, 33, 0.46)"
  },
  white: {
    border: "0",
    padding: "0.625rem 0",
    marginBottom: "20px",
    color: "#555",
    backgroundColor: "#fff !important",
    boxShadow:
      "0 4px 18px 0px rgba(0, 0, 0, 0.12), 0 7px 10px -5px rgba(0, 0, 0, 0.15)"
  },
  drawerPaper: {
    border: "none",
    bottom: "0",
    transitionProperty: "top, bottom, width",
    transitionDuration: ".2s, .2s, .35s",
    transitionTimingFunction: "linear, linear, ease",
    width: drawerWidth,
    ...boxShadow,
    position: "fixed",
    display: "block",
    top: "0",
    height: "100vh",
    visibility: "visible",
    overflowY: "visible",
    borderTop: "none",
    textAlign: "left",
    paddingRight: "0px",
    paddingLeft: "0",
    ...transition
  },
  hidden: {
    display: "none"
  },
  scrollBtn: {
    height: "50px",
    borderRadius: "0"
  },
  shop: {
    padding: "0 30px",
    height: "50px",
    background: "#f5a623",
    borderRadius: "0"
  },
  scroll: {
    "& #hidden": {
      display: "block"
    },
    position: "fixed",
    zIndex: "9",
    padding: "0",
    "& .MuiToolbar-root": {
      margin: "0",
      padding: "0",
      maxWidth: "none",
      "& div": {
        "& div": {
          display: "block"
        }
      }
    },
    [theme.breakpoints.down("sm")]: { position: "unset" }
  },
  dir: {
    right: "0",
    left: "auto"
  },
  fixedmenu: {
    position: "fixed",
    height: "100%",
    left: "auto",
    top: "0",
    right: "0",
    zIndex: "88",
    background: "#f3f3f3",
    overflow: "hidden",
    width: "45px"
  },
  fixedmenuFa: {
    position: "fixed",
    height: "100%",
    left: "0",
    top: "0",
    right: "auto",
    zIndex: "88",
    background: "#f3f3f3",
    overflow: "hidden",
    width: "45px"
  },
  shopResponsiveButton: {
    "& span span": {
      padding: "0px",
      margin: "0 0px 0 0 !important"
    },
    "& .MuiButton-label": {
      marginRight: "20px"
    },
    background: "#f5a623",
    padding: "30px 0",
    borderRadius: "0"
  },
  shopResponsiveButtonRtl: {
    "& span span": {
      padding: "0px",
      margin: "0 0px 0 0 !important"
    },
    "& .MuiButton-label": {
      marginLeft: "20px"
    },
    background: "#f5a623",
    padding: "30px 0",
    borderRadius: "0"
  },
  responsiveButton: {
    display: "table",
    padding: "10px 18px 10px 0"
  },
  responsiveButtonFa: {
    display: "table",
    padding: "10px 0px 10px 0",
    "& svg": {
      display: "none"
    },
    "& .MuiSelect-selectMenu": {
      padding: "0 3px 0 0"
    }
  },
  responsivemenuContent: {
    position: "absolute",
    bottom: "0"
  },
  drawerLogin: {
    marginRight: "45px"
  },
  responsiveButtonRtl: {
    padding: "6px 0px 10px 17px"
  }
});

export default headerStyle;
